import React, {  use, useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Grid,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PowerIcon from '@mui/icons-material/Power';
import { API_ENDPOINTS } from '../../config/constants';
import axios from 'axios'; 

// const ports = [
//   { id: 1, available: true },
//   { id: 2, available: false },
//   { id: 3, available: true },
//   { id: 4, available: true },
// ];

const PortSelection = ({ onNext,setPortData,setOrderId }) => {
  const [selectedPort, setSelectedPort] = useState({
    id: null,
    port_number: null,
  });
  const [availablePorts, setAvailablePorts] = useState([]);

  useEffect(() => {
    fetchPorts();
  }, []);

  useEffect(() => {
    console.log('Selected Port:', selectedPort);
  }, [selectedPort]);

  const fetchPorts = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(API_ENDPOINTS.GET_PORTS, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
      });
      console.log('Available Ports:', response.data);
      setAvailablePorts(response.data);
    } catch (error) {
      console.error('Error fetching ports:', error);
    }
  };

  const handlePortClick = (id,number,status) => {
    if (status=='available') setSelectedPort({
      id: id,
      port_number: number,
    });
  };

  const onProceed = async() => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.post(API_ENDPOINTS.SELECT_PORT, selectedPort, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log('Port selected successfully:', response.data);
      setPortData(selectedPort);
      setOrderId(response.data.razorpayOrder.orderId); 
      onNext();
    } catch (error) {
      console.error('Error selecting port:', error);
      alert('Failed to select port. Please try again.');
    }
  }

  return (
    <Box textAlign="center" mt={2} mx="auto">
      <Typography
        sx={{
          fontFamily: 'Mulish',
          fontWeight: 600,
          fontSize: { xs: '20px', sm: '24px' },
          lineHeight: '120%',
          color: '#261863',
          mb: 4,
        }}
      >
        Select a charging port
      </Typography>

      <Grid container spacing={3} justifyContent="center">
        {availablePorts.map((port) => (
          <Grid item xs={6} key={port._id}>
            <Box
              onClick={() => handlePortClick(port._id, port.port_number,port.status)}
              sx={{
                width: '100%',
                maxWidth: 150,
                mx: 'auto',
                position: 'relative',
                borderRadius: 2,
                p: { xs: 2, sm: 3 },
                minHeight: 140,
                cursor: port.status ? 'pointer' : 'not-allowed',
                backgroundColor: port.status ==="available" ? '#B4F0BE' : '#F6C3C3',
                fontFamily: 'Mulish',
                fontWeight: 500,
                fontSize: '18px',
                textAlign: 'center',
                transition: '0.3s',
                '&:hover': {
                  boxShadow: port.status ==="available" ? '0 0 10px rgba(0,0,0,0.2)' : 'none',
                },
              }}
            >
              {selectedPort.port_number === port.port_number && (
                <CheckCircleIcon
                  sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    color: '#261863',
                    width: 24,
                    height: 24,
                  }}
                />
              )}

              <PowerIcon sx={{ width: 36, height: 48, mb: 2 }} />
              <Typography sx={{ fontSize: 16, fontWeight: 600 }}>Port {port.port_number}</Typography>
              <Typography sx={{ fontSize: 13 }}>
                {port.status==="available" ? 'available' : 'unavailable'}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      <Button
        variant="contained"
        onClick={onProceed}
        disabled={selectedPort === null}
        sx={{
          mt: 5,
          width: '100%',
          height: '56px',
          borderRadius: '16px',
          backgroundColor: '#261863',
          color: '#fff',
          fontWeight: 'bold',
          '&:hover': {
            backgroundColor: '#1b1450',
          },
        }}
      >
        Next
      </Button>
    </Box>
  );
};

export default PortSelection;
